import React, { Component } from 'react';
import Firebase from 'firebase';
import { Route, Link } from 'react-router-dom';
import Select from 'react-select';

const gps_options = [
    { label: "Si", value: "1" },
    { label: "No", value: "0" },
    { label: "Si, solo si esta disponible", value: "2" }
]

export default class draftItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            full: false,
            button: "fa fa-bars",
            gps: props.formulario.gps
        }
        this.removeDraft = this.removeDraft.bind(this);
    }

    removeDraft() {
        var draftRef = Firebase.database().ref('draft').child(this.props.id).remove().then((resp) => {
            var logRef = Firebase.database().ref("log/" + localStorage.client_id + "/");
            var regId = Firebase.database().ref().child('log').push().key;
            logRef.child(regId).set({
                admin: localStorage.email,
                timestamp: Firebase.database.ServerValue.TIMESTAMP,
                action: "delete",
                target: {
                    type: "form",
                    id: this.props.id,
                    name: this.props.formulario.name
                }
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {
        const contex = this;
        if (nextState.full && nextState.button !== this.state.button) {
            setTimeout(function () {
                contex.setState({ button: "fa fa-arrow-left" })
            }, 800);
        }
        else if (!nextState.full && nextState.button !== this.state.button) {
            setTimeout(function () {
                contex.setState({ button: "fa fa-bars" })
            }, 800);
        }
    }


    render() {
        var url;
        if (this.props.formulario.icon) {
            url = 'iconos/' + this.props.formulario.icon + ".svg";
        } else {
            url = 'iconos/test.svg';
        }
        return (
            <div className="form-group row" style={{ border: "1px solid #CCC", borderRadius: "5px", height: "210px", boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)" }}>
                <div className="col-md-4" style={{ background: "url(img/background_draft.png)", borderBottomLeftRadius: "3px", borderTopLeftRadius: "3px" }}>
                    <Link to={"/editor/" + this.props.id}>
                        <img className="img-responsive" src={url} style={{ position: "relative", top: "20px" }} />
                    </Link>
                    <Link to={"/editor/" + this.props.id}>
                        <b style={{ position: "absolute", bottom: "10px", left: "20px", color: "#FFF", fontSize :"18px" }} >Borrador</b>
                    </Link>
                </div>
                <div className="col-md-8">
                    <h2 style={{ top: "15px", position: "relative" }}>{this.props.formulario.name}</h2>
                    <div style={{ position: "absolute", bottom: "3", right: "2" }}>
                        <button type="button" className="btn btn-outline-success" style={{ cursor: "pointer" }} onClick={() => { var l = document.getElementById('edit' + this.props.id); l.click(); }}>
                            Editar <a className="fa fa-fw fa fa-pencil" ></a>
                        </button>
                        <button type="button" className="btn btn-outline-danger" style={{ cursor: "pointer" }}  onClick={(e) => { this.removeDraft() }}>
                           Eliminar <a className="fa fa-fw fa fa-times"></a>
                        </button>
                            <Link id={"edit" + this.props.id} to={"/editor/" + this.props.id} style={{ display: "none" }} />
                    </div>
                    </div>
                </div >
                )
    }
}




// WEBPACK FOOTER //
// ./src/views/forms/draftItem.js